import axios from 'axios';
import { refreshMiniBasket } from '../basket/minibasket';
import { formatCurrency, isNumber } from '../base/utils';

import passwordReveal from '../buttons/password-reveal';
const passwordreveal = new passwordReveal();

class ChopCalculatorProduct {
    constructor() {
        this.chopCalc = document.getElementById('chop-service-calculator')

        this.frameWidthInput = document.getElementById('Short')
        this.frameHeightInput = document.getElementById('Long')
        this.errorSpan = document.getElementById('glasssizeerror')

        this.sizesPresets = document.getElementById('size-presets')
        this.sizesPresetsButtons = this.chopCalc.querySelectorAll('#size-presets button')
        this.sizesButton = document.getElementById('size-presets-button')

        this.noFrames = document.getElementById('NoOfFrames')
        this.buttonChopDown = document.getElementById('chop-no-down')
        this.buttonChopUp = document.getElementById('chop-no-up')

        this.tolerance = document.getElementById('Tolerance')
        this.toleranceBlock = document.getElementById('ToleranceBlock')
        this.hardwareKits = this.chopCalc.querySelectorAll('#js-hardware-results input[name="hardwarekitcode"]')
        this.hardwareKitCode = ''
        this.hardwareKitSummaryP = this.chopCalc.querySelector('#SelectedHWKit')
        this.hardwareKitSummary = this.chopCalc.querySelector('#SelectedHWKit .hardwarekitselected')

        this.summary = document.getElementById('Summary')
        this.priceElement = this.chopCalc.querySelector('.totalprice[data-price]')
        this.price = this.priceElement.getAttribute('data-price')
        this.frameTotalFinal = this.summary.querySelector('.frametotalfinal')
        this.frameGlassFinal = this.summary.querySelector('.frameglassfinal')
        this.extrasList = this.summary.querySelector('.extraslist')
        this.summaryToleranceBlock = this.summary.querySelector('#js-tol-block')



        this.stockAvailable = document.querySelector('#productbasket .product-stock').getAttribute('data-stock')
        this.stockAvailable = parseFloat(this.stockAvailable) * 1000
        this.chopError = document.getElementById('ChopError')

        this.basketButton = document.getElementById('AddChopToBasket')

        this.productCode = this.basketButton.getAttribute('data-code')

        this.chopkitCodes = document.querySelectorAll('.js-select-chop input[name=ChopCode]')
        this.chopImages = this.chopCalc.querySelectorAll('img[data-chop]')
    }

    init() {
        this.setup()
        this.calculatePrice()
        this.updateSummary()
    }

    setup() {
        // Optional Hardware kit
        this.hardwareKits.forEach(kit => {
            kit.addEventListener("change", () => {
                this.hardwareKitSummaryP.style.display = "flex";
                if (kit.id != 'hardwarekitcodenone') {
                    const kitName = this.chopCalc.querySelector('label[for="' + kit.id + '"]');
                    this.hardwareKitCode = kit.value
                    this.hardwareKitSummary.innerHTML = kitName.textContent.trim()
                } else {
                    this.hardwareKitSummary.innerHTML = 'No Hardware Kit'
                }
            });
        });

        // On Width or Height change
        this.frameWidthInput.addEventListener("change", () => {
            this.validateSize(this.frameWidthInput)
        });
        this.frameHeightInput.addEventListener("change", () => {
            this.validateSize(this.frameHeightInput)
        });

        // Chop select all text on focus
        this.frameWidthInput.addEventListener("click", () => {
            this.frameWidthInput.select()
        });
        this.frameHeightInput.addEventListener("click", () => {
            this.frameHeightInput.select()
        });

        // Number of frames
        this.noFrames.addEventListener("change", () => {
            if (this.noFrames.value < 1) {
                this.noFrames.value = 1
            }
            this.updateSummary();
        });

        // Chop sizes show buttons
        this.sizesButton.addEventListener("click", () => {
            const sizePresetsElement = document.getElementById('size-presets');
            const sizePresetsButtonElement = document.getElementById('size-presets-button');
            sizePresetsElement.parentNode.classList.toggle('js-open')
            sizePresetsButtonElement.innerHTML = sizePresetsButtonElement.textContent === 'Hide common sizes' ? 'Show common sizes' : 'Hide common sizes';
        });

        // Chop sizes preset buttons
        this.sizesPresetsButtons.forEach(button => {
            button.addEventListener("click", () => {
                this.frameWidthInput.value = button.getAttribute('data-short')
                this.frameHeightInput.value = button.getAttribute('data-long')
                this.updateSummary();
            });
        });

        // Chop quantity buttons 
        this.buttonChopUp.addEventListener("click", () => {
            let noInput = parseInt(this.noFrames.value, 10);
            noInput++;
            this.noFrames.value = noInput
            this.updateSummary();
            this.calculatePrice()
        });
        this.buttonChopDown.addEventListener("click", () => {
            let noInput = parseInt(this.noFrames.value, 10);
            noInput--;
            if (noInput > 0) {
                this.noFrames.value = noInput
            }
            this.updateSummary();
            this.calculatePrice()
        });

        // Tolerance checkbox
        this.tolerance.addEventListener("change", () => {
            if (this.tolerance.checked) {
                this.extrasList.innerHTML = 'Do not add 2mm tolerance'
            } else {
                this.extrasList.innerHTML = '2mm tolerance added'
            }
        });

        // Add to basket button
        this.basketButton.addEventListener("click", (e) => {
            e.preventDefault();
            this.addToBasket();
        });

        // Change Chop
        this.chopkitCodes.forEach(kit => {
            kit.addEventListener("click", () => {
                this.basketButton.setAttribute('data-code', kit.value);
                this.basketButton.setAttribute('data-price', kit.getAttribute('data-price'));
                this.productCode = this.basketButton.getAttribute('data-code');

                if (kit.getAttribute('data-tol').toLowerCase() === "true") {
                    this.toleranceBlock.style.display = "none";
                    this.summaryToleranceBlock.style.display = "none";
                } else {
                    this.toleranceBlock.style.display = "block";
                    this.summaryToleranceBlock.style.display = "flex";
                }
            });
            // Change chop type image
            this.chopkitCodes.forEach(kit => {
                kit.addEventListener("change", (e) => {
                    this.chopImages.forEach(img => {
                        const imageCode = img.getAttribute('data-chop');
                        img.style.display = (imageCode === e.target.value) ? "block" : "none";
                    });
                });
            });
        });
    }

    // Validate frame sizes
    validateSize(element) {
        if (isNumber(parseInt(element.value)) ? parseInt(element.value) : 0) {
            if (element.value < 150 || element.value > 3000) {
                if (element.value < 150) element.value = '150';
                if (element.value > 3000) element.value = '3000';
                this.errorSpan.innerHTML = "Size must be between 150mm and 3000mm";
                return false
            } else {
                this.updateSummary();
                this.errorSpan.innerHTML = '';
            }
        } else {
            this.errorSpan.innerHTML = "Size must be between 150mm and 3000mm";
            return false
        }
    }

    // Update summary section
    updateSummary() {
        const requiredQty = parseFloat(this.noFrames.value) * ((parseFloat(this.frameWidthInput.value) + parseFloat(this.frameHeightInput.value)) * 2);
        if (requiredQty > this.stockAvailable) {
            this.chopError.innerHTML = "We do not have enough stock to build that chop";
            this.disableAddToBasket()
        } else {
            this.chopError.innerHTML = "";
            this.enableAddToBasket()
        }
        this.frameTotalFinal.innerHTML = this.noFrames.value
        this.frameGlassFinal.innerHTML = this.frameWidthInput.value + "mm x " + this.frameHeightInput.value + "mm"
        this.calculatePrice()
    }

    // Calculate price
    calculatePrice() {
        const totalPrice = (((parseInt(this.frameWidthInput.value * 2) + parseInt(this.frameHeightInput.value * 2)) / 1000) * parseFloat(this.price)) * this.noFrames.value;
        this.priceElement.querySelector('span:first-child').innerHTML = formatCurrency('£', totalPrice)
    }

    disableAddToBasket() {
        this.basketButton.disabled = true
    }

    enableAddToBasket() {
        this.basketButton.disabled = false
    }

    login() {
        const div = document.createElement('div');
        div.setAttribute('id', 'ChopLogin');
        this.summary.lastElementChild.appendChild(div);
        document.getElementById('ChopLogin').innerHTML = this.showLogin();
        const chopLoginForm = document.querySelector('#ChopLoginForm a.password-toggle');
        passwordreveal.showHidePass(chopLoginForm);
        document.getElementById('AddChopToBasket').style.display = 'none';

        const loginButton = document.querySelector('#ChopLoginForm button[type=submit]');
        loginButton.addEventListener("click", (e) => {
            e.preventDefault();
            const chopLoginError = document.getElementById('choploginerror');
            if (chopLoginError) {
                chopLoginError.innerHTML = '';
            }
            const formEl = loginButton.closest("form");
            const form = new FormData(formEl);
            const request = new Request('/auth/silentlogin', {
                method: 'POST',
                body: form,
            });
            fetch(request)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.Status !== "Failed") {
                        const chopLoginForm = document.getElementById('ChopLoginForm');
                        if (chopLoginForm) {
                            chopLoginForm.remove();
                        }
                        this.addToBasket();
                    } else {
                        if (chopLoginError) {
                            chopLoginError.innerHTML = 'Email and/or password is not recognised';
                        }
                    }
                })
                .catch(error => {
                    if (chopLoginError) {
                        chopLoginError.innerHTML = 'Email and/or password is not recognised';
                    }
                    console.error('Error:', error);
                });
        });
    }

    // Add to basket 
    addToBasket() {
        const tolerance = this.tolerance.checked ? 1 : 0;
        axios.get(`/api/chopkits/add?code=${this.productCode}&quantity=${this.noFrames.value}&w=${this.frameWidthInput.value}&h=${this.frameHeightInput.value}&hcode=${this.hardwareKitCode}&t=${tolerance}`)
            .then((res) => {
                if (res.data.result == 1) {
                    this.addToBasketButtons();
                } else {
                    // Please Log In
                    this.login();
                }
            });
    }

    // Swap add to basket buttons
    addToBasketButtons() {
        this.basketButton.parentElement.insertAdjacentHTML('beforeend', '<div class="addedtobasket">Added to basket</div><div class="view-basket-link"><a href="/basket" class="btn">View Basket</a></div>')
        this.basketButton.style.display = 'none'
        refreshMiniBasket();
    }

    // Login template
    showLogin = () => `<form action="/auth/silentlogin" method="post" id="ChopLoginForm">
                        <div class="mini-login">
                            <div class="login">
                                <label for="EmailAddress">
                                    <span>Email address: </span>
                                    <input type="text" name="EmailAddress" required maxlength="200" />
                                </label>
                                <div class="password">
                                    <label for="Password">
                                        <span>Password: </span>
                                        <span class="password-wrapper">
                                            <input type="password" name="Password" required maxlength="50" />
                                            <a class="password-toggle">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="14" viewBox="0 0 21 14">
                                                    <path d="M10.5 0C4 0 0 7 0 7s3.72 7 10.5 7S21 7 21 7s-4-7-10.5-7z" fill-rule="evenodd" fill="currentColor" />
                                                    <circle cx="11" cy="7" r="4" fill="#fff" />
                                                    <circle cx="11" cy="7" r="2" fill="#54565a" />
                                                </svg>
                                            </a>
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div id="choploginerror" class="error"></div>
                            <a class="forgot" href="/forgotten-password">Forgot password?</a>
                            <footer class="login-footer">
                                <div><button class="btn" type="submit">Login</button></div>
                            </footer>
                        </div>
                    </form>`;
}
export { ChopCalculatorProduct };